export enum ValidationErrorType {
  technical = 'technical',
  length = 'length',
  userDataMissing = 'userDataMissing',
  userDataMismatch = 'userDataMismatch',
  unverifiedLicenceNumber = 'unverifiedLicenceNumber',
}

export const licenceValidationErrorMessages = (
  isAdditionaDriver?: boolean,
): Record<ValidationErrorType, string> => {
  return {
    length: 'Please make sure all 16 characters are correct',
    userDataMissing: `Please give us ${
      isAdditionaDriver ? 'their' : 'your'
    } title, name and date of birth first`,
    userDataMismatch: `That number is either incorrect, or it doesn't match ${
      isAdditionaDriver ? 'their' : 'your'
    } personal details. Please make sure ${
      isAdditionaDriver ? 'their' : 'your'
    } title, name, and date of birth match what's on ${
      isAdditionaDriver ? 'their' : 'your'
    } driver's licence.`,
    unverifiedLicenceNumber: "That licence number doesn't look quite right. Please check it again",
    technical: `Please try that again. Not ${
      isAdditionaDriver ? 'their' : 'your'
    } fault, just a technical glitch.`,
  }
}
